
const initState = {
  sidebarShow: true,
}

const changeState = (state = initState, action = {}) => {
  switch (action.type) {
    case 'set':
      return { ...state, ...action }
    default:
      return state
  }
}
export default changeState
